import React from 'react'
import styles from './segment.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const Segment = ({ classes, className, children, size = 'S' }) => (
  <div
    className={classNames(className, classes.container, {
      [classes.sizeS]: size === 'S',
      [classes.sizeM]: size === 'M',
      [classes.sizeL]: size === 'L'
    })}>
    {children}
  </div>
)

export default injectSheet(styles)(Segment)
